import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-[480px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Epic%20cinematic%20dark%20theater%20with%20warm%20golden%20spotlight%20and%20velvet%20curtains%2C%20dramatic%20stage%20lighting%2C%20movie%20premiere%20atmosphere%2C%20elegant%20and%20luxurious%20design%2C%20rich%20textures%2C%20professional%20cinematography%20style%20with%20deep%20shadows%20and%20warm%20highlights&width=1920&height=1080&seq=hero-bg-01&orientation=landscape"
        alt="成全影视 - 免费在线观看看不停"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-[800px] mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
            {t('home:heroTitle')}
            <span className="block text-primary-400 mt-2">{t('home:heroSubtitle')}</span>
          </h1>
          <p className="text-base md:text-lg text-white/70 mb-8 max-w-[600px] mx-auto leading-relaxed">
            {t('home:heroDesc')}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/dianshiju"
              className="whitespace-nowrap px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-full text-sm md:text-base transition-all cursor-pointer"
            >
              <i className="ri-play-circle-line mr-2"></i>
              {t('home:heroCta')}
            </Link>
            <Link
              to="/about"
              className="whitespace-nowrap px-8 py-3 bg-white/10 hover:bg-white/20 text-white font-medium rounded-full text-sm md:text-base transition-all cursor-pointer backdrop-blur-sm border border-white/20"
            >
              <i className="ri-information-line mr-2"></i>
              了解更多
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}